import { memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { type BaseFilterCardProps, FilterCard } from '~/components/Filters/FilterCard';
import { LocationsFilter } from '~/components/Filters/LocationsFilter/LocationsFilter';
import { clearLocationsFilterValuesAction, removeFilterAction } from '~/store/filters/actions';
import { type SelectedFilter } from '~/store/filters/types';

export type LocationsFilterCardProps = BaseFilterCardProps;

export const LocationsFilterCard = memo((props: LocationsFilterCardProps) => {
  const dispatch = useDispatch();

  const clearValues = useCallback(() => {
    dispatch(clearLocationsFilterValuesAction());
  }, [dispatch]);

  const onRemoveFilter = useCallback(
    (filter: SelectedFilter) => {
      dispatch(removeFilterAction({ filter }));
      clearValues();
    },
    [clearValues, dispatch],
  );

  return (
    <FilterCard currentFilter="locations" onClearClick={clearValues} onRemoveFilter={onRemoveFilter} {...props}>
      <LocationsFilter />
    </FilterCard>
  );
});

LocationsFilterCard.displayName = 'LocationsFilterCard';
